module.exports = __webpack_public_path__ + "8a5356e9/img/copy-icon.408fdb2d.svg";